import { makeStyles } from "@material-ui/core";

export const vehicleApprovalCardsStyle = makeStyles(theme => ({
    card: {
        margin: '0.5em 0',
        padding: '1.5em 2em',
    },
    title: {
        fontWeight: 600,
        fontSize: '1em',
        marginBottom: '1em',
    },
}));
